import React from "react";

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <circle cx="10" cy="10" r="10"></circle>
      <path
        fill="#fff"
        d="M13.603 7.302l-4.411 4.044-1.936-1.935a.833.833 0 10-1.179 1.178l2.5 2.5a.833.833 0 001.153.025l5-4.583a.833.833 0 10-1.127-1.229z"
      ></path>
    </svg>
  );
}
